export default __webpack_public_path__ + "static/media/330_business03-nl-mobile.99931f14.png";